export default 'payment';